export const videosData = [
  {
    id: 1,
    title: 'Complete Roof Replacement Project',
    thumbnail: 'https://public.readdy.ai/ai/img_res/db0619b8685c6f977eac292758672837.jpg',
    duration: '3:45',
    url: '#'
  },
  {
    id: 2,
    title: 'Siding Installation Time-lapse',
    thumbnail: 'https://readdy.ai/api/search-image?query=siding%20installation%20progress%20time%20lapse%20view%20home%20transformation%20construction%20workers%20installing%20vinyl%20siding%20professional%20work%20photography&width=600&height=400&seq=video2&orientation=landscape',
    duration: '2:30',
    url: '#'
  },
  {
    id: 3,
    title: 'Storm Damage Restoration',
    thumbnail: 'https://readdy.ai/api/search-image?query=storm%20damage%20repair%20before%20and%20after%20restoration%20work%20professional%20contractor%20repairing%20damaged%20roof%20construction%20photography&width=600&height=400&seq=video3&orientation=landscape',
    duration: '4:15',
    url: '#'
  },
  {
    id: 4,
    title: 'Seamless Gutter Installation',
    thumbnail: 'https://readdy.ai/api/search-image?query=gutter%20installation%20process%20seamless%20gutter%20machine%20professional%20contractor%20installing%20gutters%20on%20home%20construction%20photography&width=600&height=400&seq=video4&orientation=landscape',
    duration: '2:50',
    url: '#'
  },
  {
    id: 5,
    title: 'Customer Testimonial - Johnson Family',
    thumbnail: 'https://readdy.ai/api/search-image?query=happy%20homeowners%20standing%20in%20front%20of%20their%20newly%20renovated%20home%20smiling%20family%20satisfied%20customers%20beautiful%20house%20construction%20photography&width=600&height=400&seq=video5&orientation=landscape',
    duration: '1:45',
    url: '#'
  },
  {
    id: 6,
    title: 'Insurance Claim Process Explained',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20contractor%20explaining%20insurance%20claim%20process%20to%20homeowner%20consultation%20meeting%20clipboard%20documents%20construction%20photography&width=600&height=400&seq=video6&orientation=landscape',
    duration: '3:20',
    url: '#'
  }
];
